import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, GridOptions, ColDef, DomLayoutType, GridReadyEvent, ColumnApi, FilterChangedEvent, SortChangedEvent, ITooltipParams } from 'ag-grid-community';
import { RegStatusRendererComponent } from '../../cell-renderers/reg-status-renderer/reg-status-renderer.component';
import { EditButtonRendererComponent } from '../../cell-renderers/edit-button-renderer/edit-button-renderer.component';
import { PaginationPageSizes, StorageKeyNamesManage } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-vendors-list',
  templateUrl: './vendors-list.component.html',
  styleUrls: ['./vendors-list.component.scss']
})
export class VendorsListComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() isStoreParams: boolean;

  @Input() formSide: string;

  @Input() fromComponent: string;

  @Input() sectionName: string;

  idString = '';

  gridApi: GridApi;

  gridColumnApi: ColumnApi;

  public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  @Output() rowActionEvent = new EventEmitter();

  gridOptions: GridOptions;

  rowSelection: "single" | "multiple" = "single";

  selectedRows: any;

  public columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    sortable: true,
    cellDataType: false,
    minWidth: 150
  };

  public paginationPageSize = 10;

  public domLayout: DomLayoutType;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  style: any = {
    width: '100%',
    height: '100%'
  };

  paginationPageSizes = PaginationPageSizes;

  storedParams: any = {
    filterModel: {},
    sortModel: [],
    searchText: ''
  }

  constructor(private storageService: StorageService, private sharedService: SharedService) {
  }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'vendorsGrid');
    this.columnDefs = [
      {
        flex: 1,
        headerName: 'Name',
        field: 'vendor_name',
      },
      {
        flex: 1,
        headerName: 'Contact Name',
        field: 'contact_name',
      },
      {
        flex: 1,
        headerName: 'Contact Email',
        field: 'contact_email',
        tooltipValueGetter: (params: ITooltipParams) => {
          return params.data.contact_email;
        }
      },
      {
        flex: 1,
        headerName: 'Contact Number',
        field: 'contact_num',
        valueGetter: params => {
          return this.sharedService.numberFormatter(params.data.contact_num, null);
        }
      },
      {
        flex: 1,
        minWidth: 80,
        headerName: 'Action',
        headerClass: 'header-label-center',
        cellRenderer: 'editButtonRenderer',
        sortable: false,
        tooltipValueGetter: (params: ITooltipParams) => {
          return 'Edit';
        }
        // cellRendererParams: {
        //   clicked: (params: any) => {
        //     console.log('abcd aa', this.gridApi.getSelectedRows())
        //     const obj = {
        //       action: 'edit'
        //     }
        //     this.rowActionEvent.emit(obj);
        //   }
        // }
      }
    ];
    this.gridOptions = {
      sortingOrder: ['asc', 'desc'],
      pagination: true,
      suppressPaginationPanel: false,
      paginationPageSize: this.paginationPageSize,
      animateRows: true,
      context: { componentParent: this },
      onGridReady: ($event: any) => {
        this.onGridReady($event);
      },
      onFilterChanged: (e: FilterChangedEvent) => {
        this.storedParams.filterModel = e.api.getFilterModel();
        this.saveGridParams();
      },
      onSortChanged: (e: SortChangedEvent) => {
        this.storedParams.sortModel = e.columnApi.getColumnState();
        this.gridColumnApi.applyColumnState({
          state: this.storedParams.sortModel
        });
        this.saveGridParams();
      },
    }
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent
      // regStatusRenderer: RegStatusRendererComponent,
    }
    this.operateTableConfigs();
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;
            }
          });
        });
    }
  }

  checkStoredParams(storedParams: any) {
    this.gridApi.setFilterModel(storedParams.filterModel);
    this.gridApi.onFilterChanged();
    if (storedParams.sortModel.length) {
      this.gridColumnApi.applyColumnState({
        state: storedParams.sortModel
      });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.hideOverlay();
    const storedParams = this.storageService.getGridParams(this.formSide, this.fromComponent, StorageKeyNamesManage.vendorList);
    const filterModelLength = (storedParams && storedParams.filterModel) ? Object.keys(storedParams.filterModel).length : 0;
    const sortModelLength = (storedParams && storedParams.sortModel) ? (storedParams.sortModel).length : 0;
    if (storedParams && (filterModelLength || sortModelLength)) {
      this.checkStoredParams(storedParams);
    }
    // params.api.sizeColumnsToFit();
    window.setTimeout(() => {
      params.api.sizeColumnsToFit();
    }, 1000);
  }

  saveGridParams() {
    if (this.isStoreParams) {
      this.storageService.saveGridParams(this.storedParams, this.formSide, this.fromComponent, StorageKeyNamesManage.vendorList);
    }
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    this.rowEditedEvent.emit(event.data);
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.tableConfigOptions.searchText)
    } else if (!this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }
  }

}
